import React, { useEffect, useState } from 'react';
import JobsProcessesPage from '../AppUtils/CreateOpportunitiesUtils/JobsProcessesPage';
import { getAllCookies } from '../AppUtils/CreateOpportunitiesUtils/cookies'; // Import the cookie utility

function CreateOpportunities() {
  const [cookies, setCookies] = useState({});

  useEffect(() => {
    const allCookies = getAllCookies();
    setCookies(allCookies);
  }, []);

  return (
    <div>
      <JobsProcessesPage name={cookies.name} />
    </div>

  );
}

export default CreateOpportunities;